import { Button, Typography } from '@mui/material';
import React from 'react';
import { Person } from 'sr-types/lib/search/v1/graphql';
import Alert from '../../../common/components/alert/Alert';
import Loading from '../../../common/components/Loading';
import I18n from '../../../common/i18n/I18n';
import { H, V } from '../../../common/Layout';
import { useStyling } from '../../../common/Theme';

type InfoAlertProps = {
    hide: boolean;
    fieldName: string;
    showUpdateButton: boolean;
    onUpdate: () => void;
    title: string;
    description: string;
    conflictedPerson: Person;
    isPersonLoading: boolean;
    isFetchPersonDetailsError: boolean;
};

export default ({
    hide,
    fieldName,
    showUpdateButton,
    onUpdate,
    title,
    description,
    conflictedPerson,
    isPersonLoading,
    isFetchPersonDetailsError
}: InfoAlertProps) => {
    const { theme } = useStyling();
    return (
        !hide && (
            <Alert
                action={
                    showUpdateButton && (
                        <Button color="inherit" size="large" onClick={onUpdate}>
                            <I18n token="guestEditor.label.update" />
                        </Button>
                    )
                }
            >
                <V>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        <I18n token={title} values={{ field: fieldName }} />
                    </Typography>
                    <Typography>
                        <I18n token={description} values={{ field: fieldName }} />
                    </Typography>
                    {isPersonLoading ? (
                        <Loading size="18px" center={false} />
                    ) : isFetchPersonDetailsError ? (
                        <Typography sx={{ fontWeight: 'bold' }}>
                            <I18n token="person.fetch.person.details.error" />
                        </Typography>
                    ) : conflictedPerson ? (
                        Object.keys(conflictedPerson || {}).length &&
                        Object.keys(conflictedPerson).map((key, index) => (
                            <H key={index}>
                                <Typography color={theme.palette.text.disabled}>{`${key} : `}</Typography>
                                <Typography>{`${conflictedPerson[key]}`}</Typography>
                            </H>
                        ))
                    ) : (
                        <></>
                    )}
                </V>
            </Alert>
        )
    );
};
